import React, { useMemo, useState } from 'react';

import { ReportsModel } from './ReportsModel';
import { FormInput } from 'components';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter  } from '@cfa/react-components';
import { useForm } from 'react-hook-form';
import { LocationGroupsService } from 'services';

interface IReportsExportLocationGroupModalProps {
    model: ReportsModel,
    show: boolean,
    onHide: () => void,
}

type ILocationGroupForm = {
    name: string;
    // using a ref for text area location entry
};

export function ReportsExportLocationGroupModal({ model, show, onHide }: IReportsExportLocationGroupModalProps) {

    const fieldId = "location";
    const form = useForm<ILocationGroupForm>({ mode: "onTouched" });

    const [loading, setLoading] = useState(false);

    const textareaValue = useMemo<string>(() => {
        
        const field = model.allFieldsById[fieldId];
        if (!field) return '';

        const vals: string[] = [];
        const propName = field.propName;

        model.outRows.map(row => {
            if (vals.indexOf(row[propName] + '') === -1) {
                vals.push(row[propName] + '')
            }
        })

        vals.sort((a, b) => a.localeCompare(b));

        return vals.join(`\n`)
    }, []);

    const onCreateLocationGroup = () => {

        setLoading(true);

        const lines = textareaValue.split('\n');

        form.handleSubmit((formData: ILocationGroupForm) => {

            let payload = {
                name: formData.name,
                locations: lines,
            }

            setLoading(true);
            
            LocationGroupsService.postLocationGroup(payload)
                .then(() => {
                    setLoading(false);
                    onHide();
                })
                .catch((err) => {
                    setLoading(false);
                    console.error(err);
                });
        })();
    };

    return (
        <Modal show={show} onClose={onHide}>
            <ModalHeader>
                Export Location Group
            </ModalHeader>
            <ModalBody>
                <div className="locationGroups_form">
                    <div className="row">
                        <div className="col">
                            <FormInput
                                form={form}
                                label="Name"
                                name="name"
                                registerOptions={{ required: true }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col formItem">
                            <div className="formItem_label">
                                {"Locations"}
                            </div>
                        
                            <textarea
                                value={textareaValue}
                                readOnly={true}
                                className="exportColumnModal_textarea"
                                rows={8}
                            />
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button variant="outlined" onClick={onHide}>
                    Cancel
                </Button>
                <Button loading={loading} disabled={!form.formState.isValid} onClick={onCreateLocationGroup}>
                    Submit
                </Button>
            </ModalFooter>
        </Modal>
    );
}